import type { ApiOtpReference, ApiRegisterPayload } from 'src/types/userAuth';

import { useMutation } from '@tanstack/react-query';

import axios from 'src/utils/axios';

/**
 * POST /user/auth/register — creates the account (or, if the email already exists,
 * behaves as login) and emails an OTP. The response is identical for a new and an
 * existing email (anti-enumeration), so this doubles as the app's login entry point.
 */
export const useRegister = () =>
  useMutation({
    mutationFn: async (payload: ApiRegisterPayload): Promise<ApiOtpReference> => {
      const response = await axios.post<ApiOtpReference>(`/user/auth/register`, payload);
      return response.data;
    },
  });
